import { useState, useEffect, useRef } from "react";

function SEOHead() {
  useEffect(() => {
    document.title = "Hypervolar | IVF Clinic Software & Healthcare IT Solutions India";
    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };
    setMeta("description", "Hypervolar specialises in IVF clinic management software and healthcare IT — including EMR, cycle tracking, billing, CRM, and inventory. Also delivering ERP automation, AI & data systems. 5+ years | 20+ systems delivered.");
    setMeta("keywords", "IVF clinic software India, IVF management system, fertility clinic software, EMR IVF, cycle tracking software, healthcare management system HMS, hospital management system, ERP automation, AI analytics, CRM software India, Hypervolar");
    setMeta("author", "Hypervolar");
    setMeta("robots", "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1");
    setLink("canonical", "https://www.hypervolar.com/");
    setMeta("og:type", "website", true);
    setMeta("og:url", "https://www.hypervolar.com/", true);
    setMeta("og:site_name", "Hypervolar", true);
    setMeta("og:title", "Hypervolar — IVF Clinic Software & Healthcare IT Solutions", true);
    setMeta("og:description", "Specialising in IVF clinic management, EMR, and healthcare software. 5+ years | 20+ systems | India.", true);
    setMeta("og:image", "https://www.hypervolar.com/og-image.jpg", true);
    setMeta("og:locale", "en_IN", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", "Hypervolar — IVF Clinic Software & Healthcare IT Solutions");
    setMeta("twitter:description", "Specialising in IVF clinic management, EMR, and healthcare software.");
    setMeta("twitter:image", "https://www.hypervolar.com/og-image.jpg");
    setMeta("twitter:site", "@hypervolar");
    setMeta("geo.region", "IN");
    setMeta("geo.placename", "India");
    setMeta("viewport", "width=device-width, initial-scale=1");
    const injectJSON = (id, obj) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.type = "application/ld+json"; document.head.appendChild(el); }
      el.textContent = JSON.stringify(obj);
    };
    injectJSON("ld-org", { "@context": "https://schema.org", "@type": "Organization", "name": "Hypervolar", "url": "https://www.hypervolar.com", "description": "Custom software development company specialising in IVF clinic management, Healthcare IT, AI & Data Systems, and Business Automation.", "foundingDate": "2019", "areaServed": "IN", "contactPoint": { "@type": "ContactPoint", "telephone": "+91-78274-36219", "contactType": "customer service", "email": "hypervolar@gmail.com" } });
  }, []);
  return null;
}

const FontLink = () => {
  useEffect(() => {
    const l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = "https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=DM+Sans:wght@300;400;500;600&display=swap";
    document.head.appendChild(l);
  }, []);
  return null;
};

const IC = {
  Code:    () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
  Health:  () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Grid:    () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  Brain:   () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.46 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3z"/><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.46 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3z"/></svg>,
  Chart:   () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>,
  Globe:   () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  Eye:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/></svg>,
  Zap:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>,
  Monitor: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>,
  Shield:  () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  Award:   () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg>,
  Layers:  () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>,
  Sparkle: () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3l1.5 4.5L18 9l-4.5 1.5L12 15l-1.5-4.5L6 9l4.5-1.5z"/></svg>,
  Infinite:() => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 0 0 0 8c2 0 4-1.5 6-4z"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 0 0 0-8c-2 0-4 1.5-6 4z"/></svg>,
  Users:   () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  Pulse:   () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  CPU:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>,
  Arrow:   () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="7 7 17 7 17 17"/></svg>,
  Mail:    () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
  Phone:   () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.59 1.23h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.73a16 16 0 0 0 6.29 6.29l.87-.87a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21.73 16.92z"/></svg>,
  MapPin:  () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>,
  Check:   () => <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
  Quote:   () => <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor"><path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1z"/><path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z"/></svg>,
  AI:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="2"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3"/><circle cx="12" cy="12" r="6" strokeDasharray="2 3"/></svg>,
  IVF:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 2v3m0 14v3M2 12h3m14 0h3m-3.07-7.07-2.12 2.12M7.17 16.83l-2.12 2.12M19.07 19.07l-2.12-2.12M7.17 7.17 5.05 5.05"/></svg>,
  HMS:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>,
  HR:      () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"/></svg>,
  ERP:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8m-4-4v4"/><path d="M7 8h10M7 12h6"/></svg>,
  Web:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  CRM:     () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>,
  Menu:    () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
  X:       () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Stethoscope: () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"/><path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4"/><circle cx="20" cy="10" r="2"/></svg>,
  ClipBoard: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="12" y2="16"/></svg>,
  Activity: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  Package: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>,
  DollarSign: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  UserCheck: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></svg>,
};

// ─── PARTICLE CANVAS ──────────────────────────────────────────────────────────
function ParticleCanvas() {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const mouseRef = useRef({ x: -9999, y: -9999 });

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let W, H, particles = [];

    const resize = () => {
      W = canvas.width = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);

    const handleMouse = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouseRef.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    };
    canvas.addEventListener("mousemove", handleMouse);

    const count = Math.min(80, Math.floor((canvas.offsetWidth * canvas.offsetHeight) / 12000));
    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * W, y: Math.random() * H,
        vx: (Math.random() - 0.5) * 0.4, vy: (Math.random() - 0.5) * 0.4,
        r: Math.random() * 2 + 1,
        opacity: Math.random() * 0.5 + 0.15,
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      const mx = mouseRef.current.x, my = mouseRef.current.y;

      particles.forEach((p) => {
        const dx = mx - p.x, dy = my - p.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        if (dist < 120) {
          const force = (120 - dist) / 120;
          p.vx -= (dx / dist) * force * 0.08;
          p.vy -= (dy / dist) * force * 0.08;
        }
        p.vx *= 0.98; p.vy *= 0.98;
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(26,107,74,${p.opacity})`;
        ctx.fill();
      });

      particles.forEach((p, i) => {
        particles.slice(i + 1).forEach((q) => {
          const dx = p.x - q.x, dy = p.y - q.y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < 120) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.strokeStyle = `rgba(26,107,74,${0.12 * (1 - d / 120)})`;
            ctx.lineWidth = 0.6;
            ctx.stroke();
          }
        });
      });

      animRef.current = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(animRef.current);
      window.removeEventListener("resize", resize);
      canvas.removeEventListener("mousemove", handleMouse);
    };
  }, []);

  return <canvas ref={canvasRef} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", zIndex: 1 }} />;
}

// ─── TYPEWRITER ───────────────────────────────────────────────────────────────
function Typewriter({ words, speed = 80, pause = 1800 }) {
  const [display, setDisplay] = useState("");
  const [wordIdx, setWordIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    const current = words[wordIdx];
    let timeout;
    if (!deleting && charIdx <= current.length) {
      timeout = setTimeout(() => { setDisplay(current.slice(0, charIdx)); setCharIdx(c => c + 1); }, speed);
    } else if (!deleting && charIdx > current.length) {
      timeout = setTimeout(() => setDeleting(true), pause);
    } else if (deleting && charIdx >= 0) {
      timeout = setTimeout(() => { setDisplay(current.slice(0, charIdx)); setCharIdx(c => c - 1); }, speed / 2);
    } else {
      setDeleting(false);
      setWordIdx(w => (w + 1) % words.length);
    }
    return () => clearTimeout(timeout);
  }, [charIdx, deleting, wordIdx, words, speed, pause]);

  return (
    <span style={{ color: "var(--accent)", borderRight: "2px solid var(--accent)", paddingRight: "3px", animation: "blink-cursor 0.8s step-end infinite" }}>
      {display}
    </span>
  );
}

// ─── ANIMATED COUNTER ─────────────────────────────────────────────────────────
function AnimCounter({ target, suffix = "", duration = 1500 }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !started.current) {
        started.current = true;
        const start = Date.now();
        const step = () => {
          const progress = Math.min((Date.now() - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          setCount(Math.floor(eased * target));
          if (progress < 1) requestAnimationFrame(step);
          else setCount(target);
        };
        requestAnimationFrame(step);
      }
    }, { threshold: 0.3 });
    io.observe(el);
    return () => io.disconnect();
  }, [target, duration]);

  return <span ref={ref}>{count}{suffix}</span>;
}

// ─── MAGNETIC BUTTON ─────────────────────────────────────────────────────────
function MagBtn({ children, className, onClick, style }) {
  const ref = useRef(null);
  const handleMove = (e) => {
    const btn = ref.current;
    if (!btn) return;
    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    btn.style.transform = `translate(${x * 0.25}px, ${y * 0.25}px)`;
  };
  const handleLeave = () => {
    if (ref.current) ref.current.style.transform = "translate(0,0)";
  };
  return (
    <button ref={ref} className={className} onClick={onClick} style={{ transition: "transform 0.3s ease, background 0.25s, box-shadow 0.25s", ...style }}
      onMouseMove={handleMove} onMouseLeave={handleLeave}>
      {children}
    </button>
  );
}

// ─── TILT CARD ────────────────────────────────────────────────────────────────
function TiltCard({ children, className, style }) {
  const ref = useRef(null);
  const handleMove = (e) => {
    const card = ref.current;
    if (!card) return;
    const rect = card.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    card.style.transform = `perspective(600px) rotateY(${x * 6}deg) rotateX(${-y * 6}deg) translateY(-4px)`;
    card.style.boxShadow = `${-x * 10}px ${y * 10}px 30px rgba(0,0,0,0.12)`;
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.transform = "perspective(600px) rotateY(0) rotateX(0) translateY(0)";
    ref.current.style.boxShadow = "";
  };
  return (
    <div ref={ref} className={className} style={{ transition: "transform 0.15s ease, box-shadow 0.15s ease", ...style }}
      onMouseMove={handleMove} onMouseLeave={handleLeave}>
      {children}
    </div>
  );
}

// ─── REVEAL ───────────────────────────────────────────────────────────────────
function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("vis"); io.unobserve(e.target); } }),
      { threshold: 0.08 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}

// ─── CURSOR GLOW ──────────────────────────────────────────────────────────────
function CursorGlow() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;
    const move = (e) => {
      el.style.left = e.clientX + "px";
      el.style.top = e.clientY + "px";
      el.style.opacity = "1";
    };
    const leave = () => { el.style.opacity = "0"; };
    document.addEventListener("mousemove", move);
    document.addEventListener("mouseleave", leave);
    return () => { document.removeEventListener("mousemove", move); document.removeEventListener("mouseleave", leave); };
  }, []);
  return <div ref={ref} style={{ position: "fixed", pointerEvents: "none", zIndex: 9999, width: 300, height: 300, borderRadius: "50%", background: "radial-gradient(circle, rgba(26,107,74,0.06) 0%, transparent 70%)", transform: "translate(-50%, -50%)", transition: "opacity 0.3s", opacity: 0, top: 0, left: 0 }} />;
}

// ─── CSS ──────────────────────────────────────────────────────────────────────
const CSS = `
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  :root{
    --ink:#0d1117;--page:#f7f6f3;--surface:#ffffff;--surface2:#f0efe9;
    --border:#e5e3da;--border2:#d4d2c8;
    --accent:#1a6b4a;--accent2:#2d8a60;--accent-pale:#eaf4ef;--accent-mid:#c2e0d1;
    --navy:#1a2744;--navy2:#243358;
    --txt:#1a1a1a;--txt2:#4a4a52;--txt3:#8a8a96;--white:#ffffff;
    --D:'Playfair Display',serif;--B:'DM Sans',sans-serif;
    --r:12px;--r2:20px;
  }
  html{scroll-behavior:smooth}
  body{background:var(--page);color:var(--txt);font-family:var(--B);overflow-x:hidden;-webkit-font-smoothing:antialiased}
  ::selection{background:var(--accent-mid);color:var(--navy)}
  ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:var(--page)}::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px}
  a{color:inherit;text-decoration:none}

  @keyframes blink-cursor{0%,100%{border-color:var(--accent)}50%{border-color:transparent}}
  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-10px)}}
  @keyframes float2{0%,100%{transform:translateY(0) rotate(0deg)}50%{transform:translateY(-14px) rotate(2deg)}}
  @keyframes spin-slow{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
  @keyframes pulse-ring{0%{transform:scale(1);opacity:0.4}100%{transform:scale(1.8);opacity:0}}
  @keyframes slide-in-left{from{opacity:0;transform:translateX(-40px)}to{opacity:1;transform:translateX(0)}}
  @keyframes slide-in-right{from{opacity:0;transform:translateX(40px)}to{opacity:1;transform:translateX(0)}}
  @keyframes scale-in{from{opacity:0;transform:scale(0.8)}to{opacity:1;transform:scale(1)}}
  @keyframes shimmer{0%{background-position:-200% center}100%{background-position:200% center}}
  @keyframes ticker{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:.2}}
  @keyframes fadeUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
  @keyframes glow-pulse{0%,100%{box-shadow:0 0 0 0 rgba(26,107,74,0)}50%{box-shadow:0 0 24px 4px rgba(26,107,74,0.15)}}

  .reveal{opacity:0;transform:translateY(32px);transition:opacity .7s cubic-bezier(.16,1,.3,1),transform .7s cubic-bezier(.16,1,.3,1)}
  .reveal.vis{opacity:1;transform:translateY(0)}
  .reveal-left{opacity:0;transform:translateX(-32px);transition:opacity .7s cubic-bezier(.16,1,.3,1),transform .7s cubic-bezier(.16,1,.3,1)}
  .reveal-left.vis{opacity:1;transform:translateX(0)}
  .reveal-right{opacity:0;transform:translateX(32px);transition:opacity .7s cubic-bezier(.16,1,.3,1),transform .7s cubic-bezier(.16,1,.3,1)}
  .reveal-right.vis{opacity:1;transform:translateX(0)}
  .reveal-scale{opacity:0;transform:scale(0.9);transition:opacity .7s cubic-bezier(.16,1,.3,1),transform .7s cubic-bezier(.16,1,.3,1)}
  .reveal-scale.vis{opacity:1;transform:scale(1)}

  /* NAV */
  .nav{position:fixed;top:0;inset-inline:0;z-index:200;display:flex;align-items:center;justify-content:space-between;padding:0 5%;height:64px;transition:background .4s,box-shadow .3s}
  .nav.stuck{background:rgba(247,246,243,.95);backdrop-filter:blur(24px);box-shadow:0 1px 0 var(--border)}
  .logo{font-family:var(--D);font-size:1.5rem;font-weight:700;color:var(--navy);letter-spacing:.02em;position:relative}
  .logo span{color:var(--accent)}
  .logo::after{content:'';position:absolute;bottom:-2px;left:0;width:100%;height:1px;background:linear-gradient(90deg,var(--accent),transparent);transform:scaleX(0);transform-origin:left;transition:transform .4s}
  .logo:hover::after{transform:scaleX(1)}
  .nav-links{display:flex;gap:2.5rem;list-style:none}
  .nav-links a{color:var(--txt2);font-size:.85rem;font-weight:500;letter-spacing:.02em;transition:color .2s;position:relative}
  .nav-links a::after{content:'';position:absolute;bottom:-4px;left:0;width:100%;height:1.5px;background:var(--accent);transform:scaleX(0);transform-origin:left;transition:transform .3s cubic-bezier(.16,1,.3,1)}
  .nav-links a:hover{color:var(--navy)}
  .nav-links a:hover::after{transform:scaleX(1)}
  .nav-btn{padding:.6rem 1.4rem;border-radius:8px;background:var(--navy);color:var(--white);font-size:.83rem;font-weight:600;letter-spacing:.02em;cursor:pointer;border:none;font-family:var(--B);transition:all .3s;position:relative;overflow:hidden}
  .nav-btn::before{content:'';position:absolute;inset:0;background:var(--accent);transform:translateX(-100%);transition:transform .3s cubic-bezier(.16,1,.3,1)}
  .nav-btn:hover::before{transform:translateX(0)}
  .nav-btn span{position:relative;z-index:1}
  .hamburger{display:none;background:none;border:none;cursor:pointer;color:var(--navy);padding:4px;align-items:center;justify-content:center}
  .mobile-drawer{display:none;position:fixed;top:64px;left:0;right:0;bottom:0;background:rgba(247,246,243,.98);backdrop-filter:blur(20px);z-index:199;flex-direction:column;padding:2rem 5%;border-top:1px solid var(--border);overflow-y:auto}
  .mobile-drawer.open{display:flex}
  .mob-links{list-style:none;display:flex;flex-direction:column;gap:0}
  .mob-links li a{display:block;padding:1.1rem 0;font-size:1.1rem;font-weight:500;color:var(--txt);border-bottom:1px solid var(--border);letter-spacing:.01em;transition:color .2s,padding-left .2s}
  .mob-links li a:hover{color:var(--accent);padding-left:.5rem}
  .mob-cta{margin-top:2rem;padding:1rem;border-radius:10px;background:var(--navy);color:var(--white);font-weight:600;font-size:1rem;font-family:var(--B);border:none;cursor:pointer;width:100%;letter-spacing:.02em}

  /* HERO */
  .hero{min-height:100svh;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;padding:120px 5% 100px;position:relative;overflow:hidden;background:var(--surface)}
  .hero-bg{position:absolute;inset:0;z-index:0;overflow:hidden}
  .hero-blob{position:absolute;border-radius:50%;filter:blur(80px);opacity:.1;animation:float 8s ease-in-out infinite}
  .b1{width:700px;height:700px;background:#1a6b4a;top:-200px;right:-150px;animation-delay:0s}
  .b2{width:500px;height:500px;background:#1a2744;bottom:-100px;left:-100px;animation-delay:-3s}
  .b3{width:400px;height:400px;background:#2d8a60;top:40%;left:50%;transform:translate(-50%,-50%);animation-delay:-5s}
  .hero-pattern{position:absolute;inset:0;background-image:radial-gradient(var(--border) 1px,transparent 1px);background-size:28px 28px;opacity:.5}
  .hero-z{position:relative;z-index:2;max-width:900px;width:100%}
  .eyebrow{display:inline-flex;align-items:center;gap:8px;padding:6px 18px;border-radius:100px;background:var(--accent-pale);border:1px solid var(--accent-mid);font-size:.72rem;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--accent);margin-bottom:1.5rem;animation:fadeUp .8s ease both}
  .dot-g{width:6px;height:6px;border-radius:50%;background:var(--accent);animation:blink 1.4s infinite;flex-shrink:0}
  .hero-h1{font-family:var(--D);font-size:clamp(2.2rem,5vw,4.2rem);line-height:1.05;letter-spacing:-.01em;color:var(--navy);margin-bottom:1.25rem;animation:fadeUp .8s .1s ease both;font-weight:700}
  .hero-h1 em{font-style:normal;background:linear-gradient(135deg,var(--accent),var(--navy));-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;background-size:200% auto;animation:shimmer 4s linear infinite}
  .hero-p{font-size:clamp(.95rem,2vw,1.1rem);font-weight:300;color:var(--txt2);max-width:580px;margin:0 auto 2.5rem;line-height:1.85;animation:fadeUp .8s .2s ease both}
  .hero-btns{display:flex;gap:1rem;justify-content:center;flex-wrap:wrap;animation:fadeUp .8s .3s ease both}

  .btn-primary{padding:.9rem 2rem;border-radius:8px;background:var(--navy);border:none;color:var(--white);font-weight:600;font-size:.88rem;font-family:var(--B);cursor:pointer;position:relative;overflow:hidden;letter-spacing:.01em}
  .btn-primary::before{content:'';position:absolute;inset:0;background:var(--accent);transform:translateX(-100%);transition:transform .4s cubic-bezier(.16,1,.3,1)}
  .btn-primary:hover::before{transform:translateX(0)}
  .btn-primary span{position:relative;z-index:1}

  .btn-secondary{padding:.9rem 2rem;border-radius:8px;border:1.5px solid var(--border2);background:transparent;color:var(--txt);font-size:.88rem;font-weight:500;font-family:var(--B);cursor:pointer;transition:all .3s;position:relative;overflow:hidden}
  .btn-secondary::before{content:'';position:absolute;inset:0;background:var(--navy);transform:scale(0);border-radius:8px;transition:transform .4s cubic-bezier(.16,1,.3,1);transform-origin:center}
  .btn-secondary:hover::before{transform:scale(1)}
  .btn-secondary:hover{color:var(--white);border-color:var(--navy)}
  .btn-secondary span{position:relative;z-index:1}

  .hero-stats{display:flex;gap:2.5rem;justify-content:center;margin-top:3.5rem;animation:fadeUp .8s .4s ease both;flex-wrap:wrap}
  .h-stat{text-align:center;position:relative}
  .h-stat-n{font-family:var(--D);font-size:2.2rem;font-weight:700;color:var(--navy);line-height:1}
  .h-stat-l{font-size:.72rem;color:var(--txt3);font-weight:500;letter-spacing:.06em;text-transform:uppercase;margin-top:4px}
  .h-stat-div{width:1px;background:var(--border)}

  .ticker-wrap{position:absolute;bottom:0;left:0;right:0;border-top:1px solid var(--border);background:var(--surface2);height:44px;overflow:hidden;display:flex;align-items:center;z-index:3}
  .ticker-track{display:flex;white-space:nowrap;animation:ticker 30s linear infinite}
  .ticker-item{padding:0 1.5rem;font-size:.72rem;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--txt3);border-right:1px solid var(--border);flex-shrink:0;display:flex;align-items:center;gap:8px}
  .t-dot{width:3px;height:3px;border-radius:50%;background:var(--accent)}

  /* SHARED */
  .section{padding:80px 5%}
  .section-inner{max-width:1160px;margin:0 auto}
  .label{display:inline-flex;align-items:center;gap:8px;font-size:.7rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--accent);margin-bottom:1rem}
  .label-line{width:28px;height:1.5px;background:var(--accent);flex-shrink:0}
  .sec-h{font-family:var(--D);font-size:clamp(2rem,4vw,3.5rem);color:var(--navy);font-weight:700;line-height:1.1;letter-spacing:-.01em;margin-bottom:1rem}
  .sec-p{font-size:.96rem;color:var(--txt2);line-height:1.85;font-weight:300}

  /* ABOUT */
  .about{background:var(--page)}
  .about-grid{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center}
  .num-card{background:var(--navy);color:var(--white);border-radius:var(--r2);padding:2.5rem;position:relative;overflow:hidden;animation:glow-pulse 4s ease-in-out infinite}
  .num-card::before{content:'';position:absolute;top:-80px;right:-80px;width:220px;height:220px;border-radius:50%;background:rgba(255,255,255,.04)}
  .big-n{font-family:var(--D);font-size:6rem;line-height:.9;font-weight:700;color:var(--white);opacity:.95}
  .big-n span{font-size:2.4rem;opacity:.6}
  .nc-p{font-size:.88rem;color:rgba(255,255,255,.6);line-height:1.8;margin-top:1rem;font-weight:300}
  .pills{display:flex;flex-wrap:wrap;gap:6px;margin-top:1.5rem}
  .pill{padding:5px 12px;border-radius:100px;border:1px solid rgba(255,255,255,.15);background:rgba(255,255,255,.06);font-size:.7rem;font-weight:600;letter-spacing:.04em;color:rgba(255,255,255,.7);transition:all .2s;cursor:default}
  .pill:hover{background:rgba(255,255,255,.15);border-color:rgba(255,255,255,.35);transform:translateY(-2px)}
  .feat-row{display:flex;flex-direction:column;gap:.75rem;margin-top:2rem}
  .feat-item{display:flex;align-items:center;gap:1rem;padding:1rem 1.25rem;background:var(--surface);border:1px solid var(--border);border-radius:var(--r);transition:all .3s}
  .feat-item:hover{border-color:var(--accent-mid);transform:translateX(8px);box-shadow:4px 0 20px rgba(26,107,74,.08)}
  .feat-ic{width:36px;height:36px;border-radius:8px;background:var(--accent-pale);display:flex;align-items:center;justify-content:center;color:var(--accent);flex-shrink:0;transition:all .3s}
  .feat-item:hover .feat-ic{background:var(--accent);color:var(--white)}
  .feat-t{font-size:.88rem;font-weight:600;color:var(--navy)}
  .feat-d{font-size:.78rem;color:var(--txt3);margin-top:2px}

  /* SERVICES */
  .services{background:var(--surface)}
  .svc-hdr{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:3.5rem;flex-wrap:wrap;gap:2rem}
  .svc-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1px;background:var(--border);border-radius:var(--r2);overflow:hidden;border:1px solid var(--border)}
  .svc-card{background:var(--surface);padding:2.5rem 2rem;transition:all .3s;position:relative;overflow:hidden}
  .svc-card::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--accent-pale),transparent);opacity:0;transition:opacity .3s}
  .svc-card:hover{background:var(--surface)}
  .svc-card:hover::before{opacity:1}
  .svc-num{font-size:.72rem;font-weight:700;letter-spacing:.1em;color:var(--txt3);margin-bottom:1.5rem;transition:color .3s}
  .svc-card:hover .svc-num{color:var(--accent)}
  .svc-ic{width:46px;height:46px;border-radius:10px;background:var(--accent-pale);border:1px solid var(--accent-mid);display:flex;align-items:center;justify-content:center;color:var(--accent);margin-bottom:1.2rem;transition:all .3s;position:relative;z-index:1}
  .svc-card:hover .svc-ic{background:var(--accent);color:var(--white);transform:scale(1.1) rotate(5deg)}
  .svc-t{font-size:1rem;font-weight:600;color:var(--navy);margin-bottom:.6rem;position:relative;z-index:1}
  .svc-d{font-size:.82rem;color:var(--txt2);line-height:1.8;position:relative;z-index:1}
  .svc-card::after{content:'';position:absolute;bottom:0;left:2rem;right:2rem;height:2px;background:var(--accent);border-radius:2px;transform:scaleX(0);transform-origin:left;transition:transform .35s cubic-bezier(.16,1,.3,1)}
  .svc-card:hover::after{transform:scaleX(1)}
  /* Primary service card highlight */
  .svc-card.primary-svc{background:var(--accent-pale);border-bottom:3px solid var(--accent)}
  .svc-card.primary-svc .svc-num{color:var(--accent)}
  .svc-card.primary-svc .svc-ic{background:var(--accent);color:var(--white);border-color:var(--accent)}
  .svc-card.primary-svc::before{opacity:.5}

  /* PROJECTS */
  .projects{background:var(--page)}
  .proj-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1.5rem}
  .proj-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--r2);padding:2rem;cursor:default;position:relative;overflow:hidden}
  .proj-card:hover{border-color:var(--border2)}
  .proj-card.feat{grid-column:1/-1;background:var(--navy);border-color:var(--navy)}
  .proj-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:1.25rem}
  .badge{font-size:.65rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:4px 10px;border-radius:100px}
  .badge-ai{background:var(--accent-pale);color:var(--accent);border:1px solid var(--accent-mid)}
  .badge-hms{background:#e8f4ff;color:#1560a8;border:1px solid #c0dcf8}
  .badge-erp{background:#fff3e8;color:#c25a10;border:1px solid #f5d5b5}
  .badge-crm{background:#fde8f0;color:#a32356;border:1px solid #f5c0d8}
  .badge-web{background:var(--surface2);color:var(--txt2);border:1px solid var(--border)}
  .badge-flag{background:rgba(255,255,255,.12);color:rgba(255,255,255,.9);border:1px solid rgba(255,255,255,.2);font-size:.65rem;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:4px 10px;border-radius:100px}
  .proj-arr{width:30px;height:30px;border-radius:50%;border:1px solid var(--border);display:flex;align-items:center;justify-content:center;color:var(--txt3);transition:all .3s cubic-bezier(.16,1,.3,1);flex-shrink:0}
  .proj-card:hover .proj-arr{background:var(--navy);border-color:var(--navy);color:var(--white);transform:rotate(45deg) scale(1.1)}
  .proj-card.feat .proj-arr{border-color:rgba(255,255,255,.2);color:rgba(255,255,255,.5)}
  .proj-card.feat:hover .proj-arr{background:var(--accent);border-color:var(--accent);color:var(--white)}
  .proj-logo{display:flex;align-items:center;gap:10px;margin-bottom:1.25rem}
  .proj-logo-ic{width:36px;height:36px;border-radius:8px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:transform .3s}
  .proj-card:hover .proj-logo-ic{transform:rotate(-5deg) scale(1.1)}
  .proj-logo-ic.light{background:var(--accent-pale);color:var(--accent)}
  .proj-logo-ic.dark{background:rgba(255,255,255,.1);color:rgba(255,255,255,.8)}
  .proj-sub{font-size:.78rem;font-weight:600;color:var(--accent);margin-bottom:.7rem;letter-spacing:.02em}
  .proj-card.feat .proj-sub{color:rgba(255,255,255,.6)}
  .proj-d{font-size:.83rem;color:var(--txt2);line-height:1.8;margin-bottom:1.25rem}
  .proj-card.feat .proj-d{color:rgba(255,255,255,.7)}
  .tags{display:flex;flex-wrap:wrap;gap:6px}
  .tag{padding:3px 10px;border-radius:100px;font-size:.68rem;font-weight:600;letter-spacing:.04em;text-transform:uppercase;background:var(--surface2);color:var(--txt3);border:1px solid var(--border);transition:all .2s}
  .tag:hover{background:var(--accent-pale);color:var(--accent);border-color:var(--accent-mid)}
  .proj-card.feat .tag{background:rgba(255,255,255,.08);color:rgba(255,255,255,.6);border-color:rgba(255,255,255,.12)}
  .proj-card.feat .tag:hover{background:rgba(255,255,255,.18)}
  .feat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:1rem;margin:1.75rem 0 1.5rem}
  .feat-stat{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.1);border-radius:10px;padding:1.25rem;text-align:center;transition:all .3s}
  .feat-stat:hover{background:rgba(255,255,255,.12);transform:translateY(-2px)}
  .feat-stat-n{font-family:var(--D);font-size:1.8rem;font-weight:700;color:var(--white)}
  .feat-stat-l{font-size:.68rem;color:rgba(255,255,255,.5);text-transform:uppercase;letter-spacing:.08em;margin-top:2px}

  /* IVF SPOTLIGHT SECTION */
  .ivf-sec{background:var(--navy)}
  .ivf-inner{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center}
  .ivf-list{list-style:none;display:flex;flex-direction:column;gap:.85rem;margin-top:2rem}
  .ivf-list-item{display:flex;align-items:center;gap:1rem;padding:1.1rem 1.25rem;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--r);transition:all .3s;cursor:default}
  .ivf-list-item:hover{background:rgba(255,255,255,.1);border-color:var(--accent2);transform:translateX(8px)}
  .ivf-list-ic{width:38px;height:38px;border-radius:8px;background:rgba(45,138,96,.25);border:1px solid rgba(45,138,96,.4);display:flex;align-items:center;justify-content:center;color:var(--accent2);flex-shrink:0;transition:all .3s}
  .ivf-list-item:hover .ivf-list-ic{background:var(--accent);color:var(--white);border-color:var(--accent)}
  .ivf-list-t{font-size:.9rem;font-weight:600;color:var(--white)}
  .ivf-list-d{font-size:.76rem;color:rgba(255,255,255,.45);margin-top:2px}
  .ivf-badge-wrap{display:flex;flex-wrap:wrap;gap:.5rem;margin-top:2rem}

  /* TRUST SECTION */
  .trust-sec{background:var(--surface2);border-top:1px solid var(--border);border-bottom:1px solid var(--border)}
  .trust-inner{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:2rem}
  .trust-left .sec-h{font-size:clamp(1.5rem,3vw,2.2rem)}
  .trust-stat-row{display:flex;gap:2.5rem;flex-wrap:wrap}
  .trust-stat{text-align:center}
  .trust-stat-n{font-family:var(--D);font-size:2.4rem;font-weight:700;color:var(--navy);line-height:1}
  .trust-stat-l{font-size:.7rem;color:var(--txt3);font-weight:500;letter-spacing:.06em;text-transform:uppercase;margin-top:4px}

  /* AI */
  .ai-sec{background:var(--surface)}
  .ai-inner{display:grid;grid-template-columns:1fr 1fr;gap:5rem;align-items:center}
  .ai-visual{position:relative;height:420px;display:flex;align-items:center;justify-content:center}
  .ai-card-main{background:var(--navy);border-radius:var(--r2);padding:2.5rem;color:var(--white);width:300px;z-index:2;position:relative;animation:float2 6s ease-in-out infinite}
  .ai-card-label{font-size:.68rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:rgba(255,255,255,.4);margin-bottom:1rem}
  .ai-card-title{font-family:var(--D);font-size:1.5rem;font-weight:700;margin-bottom:1rem;line-height:1.1}
  .ai-tag{display:inline-block;padding:3px 8px;border-radius:4px;font-size:.65rem;font-weight:700;letter-spacing:.06em;background:rgba(255,255,255,.08);color:rgba(255,255,255,.6);margin:2px;transition:background .2s}
  .ai-tag:hover{background:rgba(255,255,255,.18)}
  .ai-float{position:absolute;background:var(--surface);border:1px solid var(--border);border-radius:var(--r);padding:.9rem 1.2rem;box-shadow:0 8px 24px rgba(0,0,0,.08)}
  .af1{top:0%;left:-30px;width:170px;animation:float 5s ease-in-out infinite;animation-delay:-1s}
  .af2{bottom:0%;right:-60px;width:165px;animation:float 7s ease-in-out infinite;animation-delay:-3s}
  .af-label{font-size:.65rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--txt3)}
  .af-val{font-size:1.3rem;font-weight:700;font-family:var(--D);color:var(--navy);margin-top:2px}
  .af-sub{font-size:.7rem;color:var(--txt3)}
  .pulse-dot{width:8px;height:8px;border-radius:50%;background:var(--accent);display:inline-block;margin-right:6px;position:relative}
  .pulse-dot::after{content:'';position:absolute;inset:-4px;border-radius:50%;border:2px solid var(--accent);animation:pulse-ring 1.5s ease-out infinite}
  .ai-feats{display:flex;flex-direction:column;gap:1rem}
  .ai-feat{display:flex;align-items:flex-start;gap:1rem;padding:1.25rem;background:var(--surface2);border-radius:var(--r);transition:all .3s;border:1px solid transparent;cursor:default}
  .ai-feat:hover{background:var(--surface);border-color:var(--border);transform:translateX(8px);box-shadow:4px 0 20px rgba(26,107,74,.06)}
  .ai-ic{width:40px;height:40px;border-radius:8px;background:var(--accent-pale);display:flex;align-items:center;justify-content:center;color:var(--accent);flex-shrink:0;transition:all .3s}
  .ai-feat:hover .ai-ic{background:var(--accent);color:var(--white)}
  .ai-ft{font-size:.9rem;font-weight:600;color:var(--navy);margin-bottom:4px}
  .ai-fd{font-size:.8rem;color:var(--txt2);line-height:1.7}

  /* WHY */
  .why{background:var(--page)}
  .why-hdr{text-align:center;margin-bottom:4rem}
  .why-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:1px;background:var(--border);border-radius:var(--r2);overflow:hidden;border:1px solid var(--border)}
  .why-card{background:var(--surface);padding:2.5rem 1.5rem;text-align:center;transition:all .3s;cursor:default}
  .why-card:hover{background:var(--accent-pale)}
  .why-ic{display:flex;justify-content:center;margin-bottom:1rem;color:var(--border2);transition:color .3s}
  .why-card:hover .why-ic{color:var(--accent)}
  .why-n{font-family:var(--D);font-size:2.8rem;font-weight:700;color:var(--navy);line-height:1;margin-bottom:.4rem}
  .why-l{font-size:.82rem;font-weight:600;color:var(--txt2);margin-bottom:.4rem}
  .why-d{font-size:.74rem;color:var(--txt3);line-height:1.6}

  /* TESTIMONIALS */
  .testi{background:var(--page)}
  .testi-hdr{text-align:center;margin-bottom:3.5rem}
  .testi-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:1.5rem}
  .testi-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--r2);padding:2rem;transition:all .3s;position:relative;overflow:hidden;cursor:default}
  .testi-card::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,var(--accent-pale),transparent);opacity:0;transition:opacity .3s}
  .testi-card:hover::before{opacity:.5}
  .t-q{color:var(--accent);opacity:.2;margin-bottom:.75rem;transition:opacity .3s}
  .testi-card:hover .t-q{opacity:.4}
  .stars{color:#e8a022;font-size:.85rem;letter-spacing:2px;margin-bottom:.75rem}
  .testi-txt{font-size:.87rem;color:var(--txt2);line-height:1.9;font-style:italic;font-weight:300;margin-bottom:1.5rem;position:relative;z-index:1}
  .testi-author{display:flex;align-items:center;gap:12px;padding-top:1rem;border-top:1px solid var(--border);position:relative;z-index:1}
  .t-av{width:42px;height:42px;border-radius:50%;background:var(--navy);display:flex;align-items:center;justify-content:center;font-family:var(--D);font-size:1.1rem;font-weight:700;color:var(--white);flex-shrink:0;transition:background .3s}
  .testi-card:hover .t-av{background:var(--accent)}
  .t-name{font-size:.88rem;font-weight:600;color:var(--navy)}
  .t-co{font-size:.72rem;color:var(--txt3)}

  /* FAQ */
  .faq{background:var(--surface)}
  .faq-hdr{text-align:center;margin-bottom:3rem}
  .faq-list{max-width:780px;margin:0 auto;display:flex;flex-direction:column;gap:1rem}
  .faq-item{background:var(--surface2);border:1px solid var(--border);border-radius:var(--r);overflow:hidden;transition:border-color .25s}
  .faq-item.open{border-color:var(--accent-mid)}
  .faq-q{display:flex;align-items:center;justify-content:space-between;padding:1.25rem 1.5rem;cursor:pointer;font-size:.93rem;font-weight:600;color:var(--navy);gap:1rem;user-select:none;transition:color .2s}
  .faq-item.open .faq-q{color:var(--accent)}
  .faq-arrow{font-size:1.2rem;color:var(--txt3);transition:transform .3s cubic-bezier(.16,1,.3,1),color .2s;flex-shrink:0}
  .faq-item.open .faq-arrow{transform:rotate(180deg);color:var(--accent)}
  .faq-a{font-size:.85rem;color:var(--txt2);line-height:1.85;padding:0 1.5rem 1.25rem;display:none}
  .faq-item.open .faq-a{display:block}

  /* CONTACT */
  .contact{background:var(--page)}
  .contact-inner{display:grid;grid-template-columns:1fr 1fr;gap:6rem;align-items:start}
  .c-items{display:flex;flex-direction:column;gap:.75rem;margin-top:2rem}
  .ci{display:flex;align-items:center;gap:1rem;padding:.9rem 1.1rem;background:var(--surface);border:1px solid var(--border);border-radius:var(--r);transition:all .3s}
  .ci:hover{border-color:var(--accent-mid);transform:translateX(6px);box-shadow:4px 0 16px rgba(26,107,74,.08)}
  .ci-ic{width:38px;height:38px;border-radius:8px;background:var(--accent-pale);border:1px solid var(--accent-mid);display:flex;align-items:center;justify-content:center;color:var(--accent);flex-shrink:0;transition:all .3s}
  .ci:hover .ci-ic{background:var(--accent);color:var(--white)}
  .ci-l{font-size:.67rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--txt3)}
  .ci-v{font-size:.88rem;font-weight:600;color:var(--navy);margin-top:2px}
  .c-form{background:var(--surface);border:1px solid var(--border);border-radius:var(--r2);padding:2.5rem;box-shadow:0 8px 40px rgba(0,0,0,.06);position:relative;overflow:hidden}
  .c-form::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--accent),var(--navy))}
  .f-h{font-family:var(--D);font-size:1.5rem;font-weight:700;color:var(--navy);margin-bottom:.4rem}
  .f-sub{font-size:.82rem;color:var(--txt3);margin-bottom:1.75rem}
  .f-l{display:block;font-size:.72rem;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:var(--txt2);margin-bottom:7px}
  .f-i,.f-ta{width:100%;background:var(--surface2);border:1px solid var(--border);border-radius:8px;padding:.85rem 1rem;color:var(--txt);font-family:var(--B);font-size:.9rem;outline:none;resize:none;transition:all .3s;margin-bottom:1.1rem;display:block}
  .f-i:focus,.f-ta:focus{border-color:var(--accent);background:var(--surface);box-shadow:0 0 0 3px var(--accent-pale)}
  .f-i::placeholder,.f-ta::placeholder{color:var(--txt3)}
  .f-btn{width:100%;padding:.95rem;border:none;border-radius:8px;background:var(--navy);color:var(--white);font-weight:600;font-family:var(--B);font-size:.92rem;cursor:pointer;transition:all .3s;letter-spacing:.02em;position:relative;overflow:hidden}
  .f-btn::before{content:'';position:absolute;inset:0;background:var(--accent);transform:translateX(-100%);transition:transform .4s cubic-bezier(.16,1,.3,1)}
  .f-btn:hover::before{transform:translateX(0)}
  .f-btn span{position:relative;z-index:1}
  .sent-wrap{text-align:center;padding:3rem 1rem}
  .sent-ic{color:var(--accent);margin-bottom:1rem;display:flex;justify-content:center}
  .sent-t{font-family:var(--D);font-size:1.6rem;font-weight:700;color:var(--navy);margin-bottom:.5rem}
  .sent-s{color:var(--txt3);font-size:.88rem}

  /* FINAL CTA */
  .final-cta{background:linear-gradient(135deg,var(--accent) 0%,var(--navy) 100%);padding:80px 5%}
  .final-cta-inner{max-width:760px;margin:0 auto;text-align:center}
  .final-cta .sec-h{color:var(--white);margin-bottom:1rem}
  .final-cta .sec-p{color:rgba(255,255,255,.65);margin-bottom:2.5rem;max-width:520px;margin-left:auto;margin-right:auto}
  .final-cta-btns{display:flex;gap:1rem;justify-content:center;flex-wrap:wrap}
  .btn-white{padding:.9rem 2rem;border-radius:8px;border:none;background:var(--white);color:var(--navy);font-weight:700;font-size:.88rem;font-family:var(--B);cursor:pointer;letter-spacing:.01em;position:relative;overflow:hidden;transition:all .3s}
  .btn-white:hover{background:var(--accent-pale);transform:translateY(-2px);box-shadow:0 8px 24px rgba(0,0,0,.2)}
  .btn-outline-white{padding:.9rem 2rem;border-radius:8px;border:1.5px solid rgba(255,255,255,.4);background:transparent;color:var(--white);font-size:.88rem;font-weight:500;font-family:var(--B);cursor:pointer;transition:all .3s}
  .btn-outline-white:hover{background:rgba(255,255,255,.1);border-color:rgba(255,255,255,.8)}

  /* FOOTER */
  footer{background:var(--navy);padding:3rem 5%}
  .foot-in{max-width:1160px;margin:0 auto;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:2rem}
  .foot-logo{font-family:var(--D);font-size:1.5rem;font-weight:700;color:var(--white)}
  .foot-logo span{color:var(--accent2)}
  .foot-tag{font-size:.73rem;color:rgba(255,255,255,.35);margin-top:4px}
  .foot-links{display:flex;gap:2rem;flex-wrap:wrap}
  .foot-links a{color:rgba(255,255,255,.45);font-size:.82rem;font-weight:500;transition:color .2s;position:relative}
  .foot-links a::after{content:'';position:absolute;bottom:-2px;left:0;width:0;height:1px;background:var(--accent2);transition:width .3s}
  .foot-links a:hover{color:var(--white)}
  .foot-links a:hover::after{width:100%}
  .copy{width:100%;text-align:center;font-size:.72rem;color:rgba(255,255,255,.25);padding-top:2rem;border-top:1px solid rgba(255,255,255,.08);margin-top:1rem}

  /* STATUS BADGE */
  .live-badge{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;border-radius:100px;background:rgba(26,107,74,.2);border:1px solid rgba(26,107,74,.3);font-size:.65rem;font-weight:700;color:rgba(255,255,255,.8);letter-spacing:.06em}

  @media(max-width:1024px){
    .about-grid,.ai-inner,.contact-inner,.ivf-inner{grid-template-columns:1fr;gap:3rem}
    .svc-grid{grid-template-columns:repeat(2,1fr)}
    .why-grid{grid-template-columns:repeat(3,1fr)}
    .testi-grid{grid-template-columns:repeat(2,1fr)}
    .feat-grid{grid-template-columns:repeat(2,1fr)}
    .proj-grid{grid-template-columns:1fr}
    .proj-card.feat{grid-column:auto}
    .ai-visual{height:300px}
    .af1{left:-10px}.af2{right:-10px}
    .trust-inner{flex-direction:column;align-items:flex-start}
  }
  @media(max-width:768px){
    .nav-links,.nav-btn{display:none}
    .hamburger{display:flex}
    .section{padding:64px 5%}
    .svc-grid{grid-template-columns:1fr}
    .svc-hdr{flex-direction:column;align-items:flex-start}
    .why-grid{grid-template-columns:repeat(2,1fr)}
    .testi-grid{grid-template-columns:1fr}
    .ai-visual{height:auto;padding:2rem 0}
    .ai-card-main{width:100%;max-width:320px}
    .af1,.af2{display:none}
    .hero-stats{gap:1.5rem}
    .h-stat-div{display:none}
    .feat-grid{grid-template-columns:repeat(2,1fr)}
    .trust-stat-row{gap:1.5rem}
  }
  @media(max-width:480px){
    .nav{padding:0 4%}.section{padding:52px 4%}.hero{padding:100px 4% 80px}
    .hero-h1{font-size:2.4rem}
    .hero-btns{flex-direction:column;align-items:center}
    .btn-primary,.btn-secondary{width:100%;max-width:300px;text-align:center}
    .hero-stats{gap:1.25rem}.h-stat-n{font-size:1.8rem}
    .why-grid{grid-template-columns:1fr 1fr}.why-card{padding:1.75rem 1rem}.why-n{font-size:2.2rem}
    .foot-in{flex-direction:column;align-items:flex-start}.foot-links{gap:1.25rem}
    .num-card{padding:1.75rem}.big-n{font-size:4.5rem}.c-form{padding:1.75rem}
    .proj-card{padding:1.5rem}.feat-grid{grid-template-columns:1fr 1fr}
    .svc-card{padding:1.75rem 1.5rem}.about-grid{gap:2rem}.testi-card{padding:1.5rem}
    .sec-h{font-size:1.9rem}
    .final-cta-btns{flex-direction:column;align-items:center}
    .btn-white,.btn-outline-white{width:100%;max-width:300px}
  }
  @media(max-width:360px){
    .hero-h1{font-size:2rem}.why-grid{grid-template-columns:1fr}
    .hero-stats{flex-direction:column;gap:1rem;align-items:center}
  }
`;

// ─── NAV ──────────────────────────────────────────────────────────────────────
function Nav() {
  const [stuck, setStuck] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => { const h = () => setStuck(window.scrollY > 30); window.addEventListener("scroll", h); return () => window.removeEventListener("scroll", h); }, []);
  useEffect(() => { document.body.style.overflow = open ? "hidden" : ""; return () => { document.body.style.overflow = ""; }; }, [open]);
  const go = (id) => { document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }); setOpen(false); };
  const NAV_ITEMS = [
    { id: "about", label: "About" },
    { id: "services", label: "Services" },
    { id: "ivf-spotlight", label: "IVF Software" },
    { id: "projects", label: "Projects" },
    { id: "contact", label: "Contact" },
  ];
  return (
    <>
      <nav className={`nav${stuck ? " stuck" : ""}`}>
        <a href="/" className="logo">HYPER<span>VOLAR</span></a>
        <ul className="nav-links">{NAV_ITEMS.map(({ id, label }) => <li key={id}><a href={`#${id}`} onClick={(e) => { e.preventDefault(); go(id); }}>{label}</a></li>)}</ul>
        <button className="nav-btn" onClick={() => go("contact")}><span>Book Demo</span></button>
        <button className="hamburger" onClick={() => setOpen(o => !o)}>{open ? <IC.X /> : <IC.Menu />}</button>
      </nav>
      <div className={`mobile-drawer${open ? " open" : ""}`}>
        <ul className="mob-links">{NAV_ITEMS.map(({ id, label }) => <li key={id}><a href={`#${id}`} onClick={(e) => { e.preventDefault(); go(id); }}>{label}</a></li>)}</ul>
        <button className="mob-cta" onClick={() => go("contact")}>Book a Demo →</button>
      </div>
    </>
  );
}

// ─── HERO ─────────────────────────────────────────────────────────────────────
// ↓ Updated ticker items to reflect healthcare/IVF focus
const TICKS = ["IVF Management", "EMR & Patient Records", "Cycle Tracking", "Healthcare IT", "Billing & Packages", "Counseling CRM", "Inventory Tracking", "5+ Years", "20+ Systems", "10+ Clinics & Companies"];

function Hero() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const items = [...TICKS, ...TICKS];
  return (
    <section id="hero" className="hero">
      <div className="hero-bg">
        <div className="hero-pattern" />
        <ParticleCanvas />
        <div className="hero-blob b1" />
        <div className="hero-blob b2" />
        <div className="hero-blob b3" />
      </div>
      <div className="hero-z">
        {/* ↓ Updated eyebrow */}
        <div className="eyebrow"><span className="dot-g" />Healthcare IT · IVF Specialists · 5+ Years of Real-World Systems</div>

        {/* ↓ Updated headline — static H1 + typewriter for variety */}
        <h1 className="hero-h1">
          Healthcare Software Solutions<br />
          with Deep Expertise in{" "}
          <Typewriter
            words={[
              "IVF Systems",
              "Clinic Management",
              "EMR & Records",
              "Patient Workflows",
            ]}
            speed={75}
            pause={2000}
          />
        </h1>

        {/* ↓ Updated subheading */}
        <p className="hero-p">
          We build smart, scalable software for healthcare — specialising in IVF clinic management, patient tracking, cycle workflows, and complete operational systems for clinics and hospitals.
        </p>

        {/* ↓ Updated CTA labels */}
        <div className="hero-btns">
          <MagBtn className="btn-primary" onClick={() => go("ivf-spotlight")}><span>Explore IVF Software →</span></MagBtn>
          <MagBtn className="btn-secondary" onClick={() => go("contact")}><span>Book a Demo</span></MagBtn>
        </div>

        <div className="hero-stats">
          {[["5", "+", "Years Experience"], null, ["20", "+", "Systems Delivered"], null, ["10", "+", "Clients Served"]].map((s, i) =>
            s ? (
              <div className="h-stat" key={i}>
                <div className="h-stat-n"><AnimCounter target={parseInt(s[0])} suffix={s[1]} /></div>
                <div className="h-stat-l">{s[2]}</div>
              </div>
            ) : <div className="h-stat-div" key={i} />
          )}
        </div>
      </div>
      <div className="ticker-wrap">
        <div className="ticker-track">{items.map((t, i) => <div className="ticker-item" key={i}><span className="t-dot" />{t}</div>)}</div>
      </div>
    </section>
  );
}

// ─── ABOUT ────────────────────────────────────────────────────────────────────
const AFEATS = [
  { Icon: IC.Pulse, t: "Healthcare-First Engineering", d: "Every system we build is designed around real clinical workflows and patient safety." },
  { Icon: IC.CPU, t: "AI-First Architecture", d: "Intelligence baked into every layer — not bolted on as an afterthought." },
  { Icon: IC.Shield, t: "Long-Term Partnership", d: "We don't ship and disappear. We stay, support, and grow with your team." },
];

function About() {
  return (
    <section id="about" className="section about">
      <div className="section-inner">
        <div className="about-grid">
          <div className="reveal-left">
            <div className="num-card">
              <div className="big-n"><AnimCounter target={5} suffix="+" /></div>
              {/* ↓ Updated description to emphasise healthcare */}
              <p className="nc-p">Expert engineers, healthcare IT specialists, and system architects who thrive where complexity meets patient care — delivering production-grade software across IVF, HMS, ERP, and AI.</p>
              <div className="pills">{["IVF Management", "EMR", "Node.js", "React", "Python", "AI / ML", "Power BI", "PostgreSQL", "Laravel", "Docker", "Automation"].map((t) => <span className="pill" key={t}>{t}</span>)}</div>
            </div>
          </div>
          <div className="reveal-right">
            <div className="label"><span className="label-line" />Our Story</div>
            {/* ↓ Updated heading and copy */}
            <h2 className="sec-h">Built for Healthcare.<br />Engineered to Scale.</h2>
            <p className="sec-p">Hypervolar was founded on one belief: every complex clinical workflow has an elegant software solution. From IVF cycle tracking to hospital management — we've proven it system by system.</p>
            <div className="feat-row">{AFEATS.map((f) => <div className="feat-item" key={f.t}><div className="feat-ic"><f.Icon /></div><div><div className="feat-t">{f.t}</div><div className="feat-d">{f.d}</div></div></div>)}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── SERVICES ─────────────────────────────────────────────────────────────────
// ↓ Reordered: Healthcare & IVF FIRST, then Business Automation, then AI & Data
const SVCS = [
  {
    n: "01",
    Icon: IC.Health,
    t: "Healthcare & IVF Systems",
    d: "Complete IVF clinic management systems including EMR, cycle tracking, counseling workflows, CRM, billing, and inventory — purpose-built for fertility clinics and hospitals.",
    primary: true,
  },
  {
    n: "02",
    Icon: IC.Grid,
    t: "Business Automation",
    d: "ERP, CRM, and workflow automation systems tailored to your business needs — eliminating manual overhead and unifying operations across departments.",
    primary: false,
  },
  {
    n: "03",
    Icon: IC.Brain,
    t: "AI & Data Systems",
    d: "Smart dashboards, predictive analytics, and automation using AI, computer vision, and ML pipelines — including our live yard-tracking system at CONCOR.",
    primary: false,
  },
];

function Services() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" className="section services">
      <div className="section-inner">
        <div className="svc-hdr reveal">
          <div>
            <div className="label"><span className="label-line" />Core Expertise</div>
            {/* ↓ Updated heading */}
            <h2 className="sec-h">Healthcare-Led.<br />Full-Stack Capable.</h2>
          </div>
          <div style={{ maxWidth: 360 }}>
            {/* ↓ Updated sub-copy */}
            <p className="sec-p">Our primary expertise is healthcare software — especially IVF clinic systems. We also deliver enterprise automation and AI solutions for businesses that need more than off-the-shelf software.</p>
            <MagBtn className="btn-primary" style={{ marginTop: "1.5rem" }} onClick={() => go("contact")}><span>Start a Project →</span></MagBtn>
          </div>
        </div>
        {/* ↓ 3-card grid (was 6) */}
        <div className="svc-grid" style={{ gridTemplateColumns: "repeat(3,1fr)" }}>
          {SVCS.map((s, i) => (
            <div className={`svc-card reveal${s.primary ? " primary-svc" : ""}`} key={s.t} style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="svc-num">{s.n}</div>
              <div className="svc-ic"><s.Icon /></div>
              <h3 className="svc-t">{s.t}</h3>
              <p className="svc-d">{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── IVF SPOTLIGHT (NEW SECTION) ──────────────────────────────────────────────
const IVF_FEATURES = [
  { Icon: IC.ClipBoard,   t: "EMR & Patient Records",          d: "Structured electronic records for every patient — from first visit to cycle completion." },
  { Icon: IC.UserCheck,  t: "Counseling & Lead Management",    d: "Track inquiries, counseling sessions, and conversions in one unified CRM pipeline." },
  { Icon: IC.Activity,   t: "Stimulation & Cycle Tracking",    d: "Day-by-day cycle monitoring, stimulation protocols, follicle data, and embryology lab records." },
  { Icon: IC.DollarSign, t: "Billing & Package Management",    d: "Flexible billing for IVF packages, treatments, and insurance — automated and auditable." },
  { Icon: IC.Package,    t: "Inventory & Medicine Tracking",   d: "Real-time stock management for fertility drugs, consumables, and lab supplies." },
];

function IVFSpotlight() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="ivf-spotlight" className="section ivf-sec">
      <div className="section-inner">
        <div className="ivf-inner">
          {/* Left: content */}
          <div className="reveal-left">
            <div className="label" style={{ color: "var(--accent2)" }}>
              <span style={{ width: 28, height: 1.5, background: "var(--accent2)", display: "inline-block" }} />
              Flagship Expertise
            </div>
            <h2 className="sec-h" style={{ color: "var(--white)" }}>
              Specialised in<br />IVF Clinic Software
            </h2>
            <p className="sec-p" style={{ color: "rgba(255,255,255,.6)", marginTop: ".75rem", marginBottom: "2rem" }}>
              Our flagship expertise lies in building complete IVF management systems designed around real clinic workflows — from patient entry to cycle completion. Every module is shaped by how fertility clinics actually operate.
            </p>
            <ul className="ivf-list">
              {IVF_FEATURES.map((f) => (
                <li className="ivf-list-item" key={f.t}>
                  <div className="ivf-list-ic"><f.Icon /></div>
                  <div>
                    <div className="ivf-list-t">{f.t}</div>
                    <div className="ivf-list-d">{f.d}</div>
                  </div>
                </li>
              ))}
            </ul>
            <div style={{ marginTop: "2.5rem", display: "flex", gap: "1rem", flexWrap: "wrap" }}>
              <MagBtn className="btn-primary" onClick={() => go("contact")} style={{ background: "var(--accent)" }}><span>Book a Demo →</span></MagBtn>
              <MagBtn className="btn-secondary" onClick={() => go("projects")} style={{ borderColor: "rgba(255,255,255,.3)", color: "rgba(255,255,255,.8)" }}><span>See Our Work</span></MagBtn>
            </div>
          </div>

          {/* Right: stat cards */}
          <div className="reveal-right">
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
              {[
                { n: "1", suffix: "", label: "Complete IVF System", sub: "end-to-end, live in clinics" },
                { n: "5", suffix: "+", label: "Healthcare Systems", sub: "HMS, IVF, CRM & more" },
                { n: "20", suffix: "+", label: "Systems Delivered", sub: "across all domains" },
                { n: "5", suffix: "+", label: "Years in Healthcare IT", sub: "with long-term support" },
              ].map((s) => (
                <div key={s.label} style={{
                  background: "rgba(255,255,255,.06)",
                  border: "1px solid rgba(255,255,255,.1)",
                  borderRadius: "var(--r2)",
                  padding: "2rem 1.5rem",
                  textAlign: "center",
                  transition: "all .3s",
                  cursor: "default",
                }}
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,.12)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,.06)"; e.currentTarget.style.transform = "translateY(0)"; }}
                >
                  <div style={{ fontFamily: "var(--D)", fontSize: "3rem", fontWeight: 700, color: "var(--white)", lineHeight: 1 }}>
                    <AnimCounter target={parseInt(s.n)} suffix={s.suffix} />
                  </div>
                  <div style={{ fontSize: ".82rem", fontWeight: 600, color: "var(--accent2)", marginTop: ".5rem" }}>{s.label}</div>
                  <div style={{ fontSize: ".72rem", color: "rgba(255,255,255,.35)", marginTop: ".25rem" }}>{s.sub}</div>
                </div>
              ))}
            </div>
            {/* Live system callout */}
            <div style={{
              marginTop: "1.5rem",
              background: "rgba(26,107,74,.2)",
              border: "1px solid rgba(26,107,74,.4)",
              borderRadius: "var(--r)",
              padding: "1.25rem 1.5rem",
              display: "flex",
              alignItems: "flex-start",
              gap: "1rem",
            }}>
              <span style={{ marginTop: 2 }}><span className="pulse-dot" style={{ position: "static" }} /></span>
              <div>
                <div style={{ fontSize: ".85rem", fontWeight: 600, color: "var(--white)" }}>Aveya IVF — Live System</div>
                <div style={{ fontSize: ".76rem", color: "rgba(255,255,255,.5)", marginTop: "3px", lineHeight: 1.6 }}>
                  Our flagship IVF management platform is actively used by Aveya IVF clinic — covering patient records, cycle tracking, billing, and clinic operations.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── TRUST / PROOF SECTION (NEW) ──────────────────────────────────────────────
function TrustSection() {
  return (
    <section className="section trust-sec">
      <div className="section-inner">
        <div className="trust-inner reveal">
          <div className="trust-left">
            <div className="label"><span className="label-line" />Proof</div>
            <h2 className="sec-h" style={{ marginBottom: ".75rem" }}>Trusted by Clinics</h2>
            <p className="sec-p" style={{ maxWidth: 440 }}>
              Our systems are already used by IVF clinics and healthcare providers to streamline operations, improve patient management, and reduce administrative overhead — every single day.
            </p>
          </div>
          <div className="trust-stat-row">
            {[
              { n: 5, suffix: "+", label: "Clinics & Hospitals" },
              { n: 20, suffix: "+", label: "Modules Delivered" },
              { n: 100, suffix: "%", label: "Production Systems" },
            ].map((s) => (
              <div className="trust-stat" key={s.label}>
                <div className="trust-stat-n"><AnimCounter target={s.n} suffix={s.suffix} /></div>
                <div className="trust-stat-l">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── PROJECTS ─────────────────────────────────────────────────────────────────
// ↓ IVF projects moved to top of the list
const PROJS = [
  { id: "01", cat: "HEALTHCARE · IVF", badgeCls: "badge-hms", Icon: IC.IVF, name: "AVEYA IVF", sub: "IVF Clinic Management System", desc: "End-to-end IVF workflow covering patient intake, EMR, cycle tracking, embryology lab, counseling CRM, billing, and reporting — purpose-built for fertility clinics.", tags: ["IVF", "EMR", "CRM", "Web App"] },
  { id: "02", cat: "HEALTHCARE · HMS", badgeCls: "badge-hms", Icon: IC.HMS, name: "LIFELINKR", sub: "Hospital Management System", desc: "Comprehensive multi-department HMS covering OPD, IPD, pharmacy, lab, radiology, and finance — unified in a single intelligent platform.", tags: ["HMS", "Automation", "Web App"] },
  { id: "03", cat: "PLATFORM", badgeCls: "badge-web", Icon: IC.Web, name: "360PLOT", sub: "Real Estate Visualization Platform", desc: "A digital platform for interactive property visualization, enabling users to explore plots, layouts, and project details with a seamless and intuitive interface.", tags: ["Real Estate", "Visualization"] },
  { id: "05", cat: "HEALTHCARE + WEB", badgeCls: "badge-hms", Icon: IC.Web, name: "SCIHOSPITAL", sub: "Website & Technical Support", desc: "Professional website development and long-term technical support — covering design, performance, SEO, and continuity for a healthcare provider.", tags: ["Web", "Healthcare"] },
  { id: "06", cat: "CRM", badgeCls: "badge-crm", Icon: IC.CRM, name: "VATSALYA", sub: "CRM & Client Management System", desc: "Smart CRM with lead tracking, customer lifecycle, follow-up automation, and reporting dashboards for healthcare and service sectors.", tags: ["CRM", "Automation"] },
];

function Projects() {
  return (
    <section id="projects" className="section projects">
      <div className="section-inner">
        <div className="reveal" style={{ marginBottom: "3rem" }}>
          <div className="label"><span className="label-line" />Our Work</div>
          <h2 className="sec-h">Work That<br />Speaks for Itself.</h2>
          <p className="sec-p" style={{ maxWidth: 480, marginTop: ".75rem" }}>A track record of complex healthcare and enterprise systems delivered — running at scale, every day.</p>
        </div>
        <div className="proj-grid">
          {/* Flagship AI card */}
          <TiltCard className="proj-card feat reveal">
            <div className="proj-top">
              <span className="badge-flag">AI Vision · Flagship</span>
              <span className="proj-arr"><IC.Arrow /></span>
            </div>
            <div className="proj-logo">
              <div className="proj-logo-ic dark"><IC.AI /></div>
              <h3 style={{ fontFamily: "var(--D)", fontSize: "1.5rem", fontWeight: 700, color: "var(--white)", letterSpacing: ".04em" }}>CONCOR</h3>
            </div>
            <div className="proj-sub">AI-Based Yard Automation — Computer Vision System</div>
            <p className="proj-d" style={{ maxWidth: 640 }}>Real-time computer vision platform for autonomous container and vehicle tracking at one of India's largest container logistics companies. Integrates live camera feeds, OCR, and custom ML models — eliminating manual tracking entirely.</p>
            <div className="feat-grid">
              {[["90%", "Error Reduction"], ["Real-Time", "Live Tracking"], ["Custom ML", "Models Built"], ["Autonomous", "Yard Ops"]].map(([n, l]) => (
                <div className="feat-stat" key={l}><div className="feat-stat-n">{n}</div><div className="feat-stat-l">{l}</div></div>
              ))}
            </div>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "1rem" }}>
              <div className="tags">{["AI", "Vision", "Automation", "Logistics", "ML"].map((t, i) => <span className="tag" key={i}>{t}</span>)}</div>
              <div className="live-badge"><span className="pulse-dot" style={{ position: "static" }} />Live in Production</div>
            </div>
          </TiltCard>

          {PROJS.map((p, i) => (
            <TiltCard className="proj-card reveal" key={p.name} style={{ transitionDelay: `${i * 60}ms` }}>
              <div className="proj-top">
                <span className={`badge ${p.badgeCls}`}>{p.id} — {p.cat}</span>
                <span className="proj-arr"><IC.Arrow /></span>
              </div>
              <div className="proj-logo">
                <div className="proj-logo-ic light"><p.Icon /></div>
                <h3 style={{ fontFamily: "var(--D)", fontSize: "1.2rem", fontWeight: 700, color: "var(--navy)", letterSpacing: ".03em" }}>{p.name}</h3>
              </div>
              <div className="proj-sub">{p.sub}</div>
              <p className="proj-d">{p.desc}</p>
              <div className="tags">{p.tags.map((t, j) => <span className="tag" key={j}>{t}</span>)}</div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── INNOVATION ───────────────────────────────────────────────────────────────
const AIFEATS = [
  { Icon: IC.Eye, t: "Vision AI for Yard & Container Tracking", d: "Live camera-based recognition and tracking of containers, vehicles, and assets. Deployed at CONCOR." },
  { Icon: IC.Zap, t: "Intelligent Process Automation", d: "ML-driven workflows eliminating manual bottlenecks — from document processing to predictive logistics routing." },
  { Icon: IC.Monitor, t: "Real-Time Monitoring Systems", d: "Live dashboards and alert systems that surface critical events the moment they happen across operations and healthcare." },
  { Icon: IC.Brain, t: "Custom ML Model Development", d: "Purpose-built models trained on your domain data — classification, object detection, NLP, and predictive analytics." },
];

function Innovation() {
  return (
    <section id="innovation" className="section ai-sec">
      <div className="section-inner">
        <div className="ai-inner">
          <div className="ai-visual reveal-left">
            <div className="ai-card-main">
              <div className="ai-card-label">Intelligence Layer</div>
              <div className="ai-card-title">Vision AI<br />Yard Tracking</div>
              <div>{["Computer Vision", "OCR Engine", "Custom ML", "Real-Time Feed"].map((t) => <span className="ai-tag" key={t}>{t}</span>)}</div>
              <div style={{ marginTop: "1.5rem", display: "flex", alignItems: "center", gap: "8px" }}>
                <span className="pulse-dot" />
                <span style={{ fontSize: ".78rem", color: "rgba(255,255,255,.5)" }}>Live at CONCOR</span>
              </div>
            </div>
            <div className="ai-float af1">
              <div className="af-label">Error Reduction</div>
              <div className="af-val">90%</div>
              <div className="af-sub">vs manual tracking</div>
            </div>
            <div className="ai-float af2">
              <div className="af-label">Detection Speed</div>
              <div className="af-val">&lt;1s</div>
              <div className="af-sub">real-time identification</div>
            </div>
          </div>
          <div className="reveal-right">
            <div className="label"><span className="label-line" />AI & Innovation</div>
            <h2 className="sec-h">AI &amp; Machine Learning<br />Built In.</h2>
            <p className="sec-p" style={{ marginTop: ".75rem", marginBottom: "2rem" }}>Hypervolar doesn't bolt AI on as an afterthought. We architect intelligent systems from the ground up — with computer vision, ML pipelines, and real-time automation at the core.</p>
            <div className="ai-feats">{AIFEATS.map((f) => <div className="ai-feat" key={f.t}><div className="ai-ic"><f.Icon /></div><div><div className="ai-ft">{f.t}</div><div className="ai-fd">{f.d}</div></div></div>)}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── WHY ──────────────────────────────────────────────────────────────────────
const WHY = [
  { Icon: IC.Award, n: 5, suffix: "+", l: "Years Experience", d: "Proven across healthcare, IVF, enterprise, and AI." },
  { Icon: IC.Layers, n: 20, suffix: "+", l: "Systems Delivered", d: "Production systems running at real clinics and companies." },
  { Icon: IC.Sparkle, n: null, label: "IVF", l: "Deep Specialisation", d: "Dedicated healthcare IT expertise, not a generic agency." },
  { Icon: IC.Infinite, n: null, label: "∞", l: "Scalable Architecture", d: "We build for the next 5 years — no technical debt." },
  { Icon: IC.Users, n: null, label: "24/7", l: "Reliable Support", d: "Long-term partnership, not one-time delivery." },
];

function Why() {
  return (
    <section className="section why">
      <div className="section-inner">
        <div className="why-hdr reveal">
          <div className="label" style={{ justifyContent: "center" }}><span className="label-line" />Why Us</div>
          <h2 className="sec-h">Why Clinics Choose Hypervolar</h2>
          <p className="sec-p" style={{ maxWidth: 500, margin: ".75rem auto 0" }}>Deep domain expertise in healthcare IT, a commitment to long-term partnerships, and a problem-solving DNA that runs through everything we build.</p>
        </div>
        <div className="why-grid">
          {WHY.map((w, i) => (
            <div className="why-card reveal" key={w.l} style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="why-ic"><w.Icon /></div>
              <div className="why-n">{w.n !== null ? <AnimCounter target={w.n} suffix={w.suffix} /> : w.label}</div>
              <div className="why-l">{w.l}</div>
              <div className="why-d">{w.d}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── TESTIMONIALS ─────────────────────────────────────────────────────────────
const TESTIS = [
  { av: "S", name: "Sukhwant Gandhi", co: "Director, Aveya IVF", text: "The IVF management system developed by Hypervolar transformed our clinic operations. From patient tracking to reporting, everything is now efficient and reliable." },
  { av: "B", name: "Bharat Singh", co: "Founder, 360Plot", text: "Their ability to understand complex requirements and convert them into scalable software is outstanding. The platform they delivered is fast, reliable, and future-ready." },
  { av: "V", name: "Vatsalya Team", co: "CRM Platform", text: "The CRM system built by Hypervolar helped us manage leads, follow-ups, and customer relationships efficiently. It significantly improved our workflow and tracking." },
  { av: "S", name: "SCI Hospital Team", co: "Healthcare Platform", text: "Hypervolar provided excellent website and technical support services. Their team ensured smooth performance, reliability, and long-term stability for our digital presence." },
];

function Testimonials() {
  return (
    <section className="section testi">
      <div className="section-inner">
        <div className="testi-hdr reveal">
          <div className="label" style={{ justifyContent: "center" }}><span className="label-line" />Client Voices</div>
          <h2 className="sec-h">What Clients Say</h2>
          <p className="sec-p" style={{ maxWidth: 440, margin: ".75rem auto 0" }}>Don't take our word for it. Here's what the clinics and companies we've built for have to say.</p>
        </div>
        <div className="testi-grid">
          {TESTIS.slice(0, 3).map((t, i) => (
            <TiltCard className="testi-card reveal" key={t.name} style={{ transitionDelay: `${i * 90}ms` }}>
              <div className="t-q"><IC.Quote /></div>
              <div className="stars">★★★★★</div>
              <blockquote className="testi-txt">"{t.text}"</blockquote>
              <div className="testi-author"><div className="t-av">{t.av}</div><div><div className="t-name">{t.name}</div><div className="t-co">{t.co}</div></div></div>
            </TiltCard>
          ))}
        </div>
        <div className="testi-grid" style={{ marginTop: "1.5rem" }}>
          {TESTIS.slice(3).map((t, i) => (
            <TiltCard className="testi-card reveal" key={t.name} style={{ transitionDelay: `${i * 90}ms` }}>
              <div className="t-q"><IC.Quote /></div>
              <div className="stars">★★★★★</div>
              <blockquote className="testi-txt">"{t.text}"</blockquote>
              <div className="testi-author"><div className="t-av">{t.av}</div><div><div className="t-name">{t.name}</div><div className="t-co">{t.co}</div></div></div>
            </TiltCard>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── FAQ ──────────────────────────────────────────────────────────────────────
// ↓ Updated FAQs to be healthcare/IVF oriented
const FAQS = [
  { q: "What does Hypervolar specialise in?", a: "Hypervolar specialises in healthcare IT software — with deep expertise in IVF clinic management systems, including EMR, cycle tracking, counseling CRM, billing, and inventory. We also deliver hospital management systems (HMS), business automation (ERP/CRM), and AI & data systems for enterprises." },
  { q: "What does your IVF management system include?", a: "Our IVF system covers the complete clinic workflow: EMR and patient records, counseling and lead management CRM, stimulation and cycle tracking, embryology lab records, billing and package management, and inventory/medicine tracking. It is built specifically for how fertility clinics operate — not adapted from generic HMS software." },
  { q: "Has your IVF software been deployed at a real clinic?", a: "Yes. Our IVF management system is live and actively used at Aveya IVF clinic, handling daily patient management, cycle tracking, billing, and clinic operations. It's a production system — not a prototype." },
  { q: "What other healthcare systems has Hypervolar built?", a: "Beyond IVF, we have delivered LifeLinkr — a comprehensive multi-department Hospital Management System (HMS) — as well as the SCI Hospital website and technical support platform, and the Vatsalya CRM for healthcare client management." },
  { q: "How do I book a demo or start a project?", a: "You can fill in the contact form below, email us at hypervolar@gmail.com, or call +91 78274 36219. We typically respond within 24 hours and can arrange a live demo of our IVF system for interested clinics." },
];

function FAQ() {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(prev => prev === i ? null : i);
  return (
    <section className="section faq">
      <div className="section-inner">
        <div className="faq-hdr reveal">
          <div className="label" style={{ justifyContent: "center" }}><span className="label-line" />FAQ</div>
          <h2 className="sec-h">Frequently Asked Questions</h2>
          <p className="sec-p" style={{ maxWidth: 480, margin: ".75rem auto 0" }}>Everything you need to know about Hypervolar's healthcare software and how we work.</p>
        </div>
        <div className="faq-list reveal">
          {FAQS.map((f, i) => (
            <div className={`faq-item${open === i ? " open" : ""}`} key={i}>
              <div className="faq-q" onClick={() => toggle(i)} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && toggle(i)} aria-expanded={open === i}>
                <span>{f.q}</span>
                <span className="faq-arrow">▾</span>
              </div>
              <div className="faq-a">{f.a}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── CONTACT ──────────────────────────────────────────────────────────────────
const CITEMS = [
  { Icon: IC.Mail, l: "Email", v: "hypervolar@gmail.com", link: "mailto:hypervolar@gmail.com" },
  { Icon: IC.Phone, l: "Phone", v: "+91 78274 36219", link: "tel:+917827436219" },
  { Icon: IC.MapPin, l: "Location", v: "India · Remote-First" },
];

function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSend = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch("https://nexcrm.run.place/contact", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(form),
      });
      if (res.ok) { setSent(true); setForm({ name: "", email: "", message: "" }); }
      else alert("Something went wrong");
    } catch { alert("Server error"); }
    setLoading(false);
  };
  return (
    <section id="contact" className="section contact">
      <div className="section-inner">
        <div className="contact-inner">
          <div className="reveal-left">
            <div className="label"><span className="label-line" />Get In Touch</div>
            {/* ↓ Updated heading */}
            <h2 className="sec-h">Let's Build<br />Together</h2>
            <p className="sec-p" style={{ marginTop: "1rem" }}>Whether you're running an IVF clinic, a hospital, or an enterprise — every great Hypervolar solution starts with a conversation. Tell us what you need.</p>
            <address className="c-items" style={{ fontStyle: "normal" }}>
              {CITEMS.map((c) => (
                <div className="ci" key={c.l}>
                  <div className="ci-ic"><c.Icon /></div>
                  <div><div className="ci-l">{c.l}</div><div className="ci-v">{c.link ? <a href={c.link}>{c.v}</a> : c.v}</div></div>
                </div>
              ))}
            </address>
          </div>
          <div className="c-form reveal-right">
            {!sent ? (
              <>
                <div className="f-h">Start a Conversation</div>
                {/* ↓ Updated form sub-copy */}
                <p className="f-sub">Interested in our IVF software or another system? Tell us about your clinic or project — we respond within 24 hours.</p>
                <form onSubmit={handleSend} noValidate>
                  <label className="f-l" htmlFor="cn">Name</label>
                  <input id="cn" className="f-i" name="name" value={form.name} onChange={handleChange} placeholder="Your name" required autoComplete="name" />
                  <label className="f-l" htmlFor="ce">Email</label>
                  <input id="ce" className="f-i" name="email" type="email" value={form.email} onChange={handleChange} placeholder="Your email" required autoComplete="email" />
                  <label className="f-l" htmlFor="cm">Message</label>
                  <textarea id="cm" className="f-ta" name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your clinic or project" rows={4} required />
                  <button className="f-btn" type="submit"><span>{loading ? "Sending…" : "Send Message →"}</span></button>
                </form>
              </>
            ) : (
              <div className="sent-wrap">
                <div className="sent-ic"><IC.Check /></div>
                <div className="sent-t">Message Sent!</div>
                <p className="sent-s">We'll be in touch within 24 hours.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── FINAL CTA SECTION (NEW) ──────────────────────────────────────────────────
function FinalCTA() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="final-cta">
      <div className="final-cta-inner reveal">
        <div className="label" style={{ justifyContent: "center", color: "rgba(255,255,255,.5)" }}>
          <span style={{ width: 28, height: 1.5, background: "rgba(255,255,255,.3)", display: "inline-block" }} />
          Ready to Transform Your Clinic?
        </div>
        <h2 className="sec-h">Looking for a Better Way<br />to Manage Your Clinic?</h2>
        <p className="sec-p">Stop running your IVF clinic on spreadsheets and fragmented software. Let's build a system that actually fits how your clinic works — from patient intake to cycle completion.</p>
        <div className="final-cta-btns">
          <MagBtn className="btn-white" onClick={() => go("contact")}><span>Book a Demo →</span></MagBtn>
          <button className="btn-outline-white" onClick={() => go("contact")}>Contact Us</button>
        </div>
      </div>
    </section>
  );
}

// ─── FOOTER ───────────────────────────────────────────────────────────────────
function Footer() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer>
      <div className="foot-in">
        <div>
          <div className="foot-logo">HYPER<span>VOLAR</span></div>
          {/* ↓ Updated tagline */}
          <div className="foot-tag">IVF Software · Healthcare IT · Business Automation · AI Systems · India</div>
        </div>
        <nav className="foot-links">
          {[
            { id: "about", label: "About" },
            { id: "services", label: "Services" },
            { id: "ivf-spotlight", label: "IVF Software" },
            { id: "projects", label: "Projects" },
            { id: "contact", label: "Contact" },
          ].map(({ id, label }) => (
            <a href={`#${id}`} key={id} onClick={(e) => { e.preventDefault(); go(id); }}>{label}</a>
          ))}
        </nav>
        <div className="copy">© {new Date().getFullYear()} Hypervolar · Healthcare IT & IVF Software Development Company India · All rights reserved</div>
      </div>
    </footer>
  );
}

// ─── ROOT ─────────────────────────────────────────────────────────────────────
export default function HypervolarHealthcare() {
  useReveal();

  useEffect(() => {
    const allReveal = document.querySelectorAll(".reveal-left, .reveal-right, .reveal-scale");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("vis"); io.unobserve(e.target); } }),
      { threshold: 0.08 }
    );
    allReveal.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <SEOHead />
      <style>{CSS}</style>
      <FontLink />
      <CursorGlow />
      <a href="#hero" style={{ position: "absolute", left: "-9999px", top: "auto", width: "1px", height: "1px", overflow: "hidden" }}>Skip to main content</a>
      <Nav />
      <main id="main-content">
        <Hero />
        <About />
        <Services />
        <IVFSpotlight />       {/* ← NEW: IVF deep-dive section */}
        <TrustSection />       {/* ← NEW: "Trusted by Clinics" proof section */}
        <Projects />
        <Innovation />
        <Why />
        <Testimonials />
        <FAQ />
        <Contact />
        <FinalCTA />           {/* ← NEW: Final CTA before footer */}
      </main>
      <Footer />
    </>
  );
}